<template>
  <div class="filter-component">
    <h4>{{ title }}</h4>
    <div class="filter-component__num-input">
      <input type="number" v-model="min" placeholder="Min" @blur="updateIntervalFilter()"
        @keyup.enter="updateIntervalFilter()" />
      <span class="icon icon--minus"></span>
      <input type="number" v-model="max" placeholder="Max" @blur="updateIntervalFilter()"
        @keyup.enter="updateIntervalFilter()" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, Ref, watch } from "vue";
import { useFilterStore } from "../../stores/filterStore";
import { IFilter } from "interfaces/filter/IFilter";
import { useFilterState } from "@/services/filter-state-service";

const filterStore = useFilterStore();
const { updateFilter } = useFilterState();

const props = defineProps({
  title: String,
  dataKey: String
});

onMounted(() => {
  const existingFilter = filterStore.activeFilters.find(
    (filter: IFilter) => filter.dataKey === props.dataKey);

  if (existingFilter) {
    min.value = existingFilter.value.min;
    max.value = existingFilter.value.max;
  }
});

const min: Ref<number | null | string> = ref(null);
const max: Ref<number | null | string> = ref(null);

function updateIntervalFilter() {
  // We only accept numbers or null values
  const minVal = min.value === '' ? null : min.value;
  const maxVal = max.value === '' ? null : max.value;

  if ((minVal === null || typeof minVal === 'number') && (maxVal === null || typeof maxVal === 'number')) {
    const filter: IFilter = {
      dataKey: props.dataKey ?? '',
      value: {
        min: minVal,
        max: maxVal
      }
    };

    updateFilter(filter);
  }
}

// Reset min and max if all filters are removed
watch(filterStore.activeFilters, (newFilters )=> {
  if (newFilters.length === 0) {
    min.value = null;
    max.value = null;
  }
});

</script>